import React, { useState } from "react";
interface ShowMoreTextProps {
  text: string;
  maxChars?: number;
}
const ShowMoreText: React.FC<ShowMoreTextProps> = ({
  text,
  maxChars = 150
}) => {
  const [isExpanded, setIsExpanded] = useState(false);
  const toggleText = () => setIsExpanded(prev => !prev);
  const textDisplay = text || "";
  const shouldTruncate = textDisplay?.length > maxChars;
  const displayedText = isExpanded || !shouldTruncate ? textDisplay : textDisplay.slice(0, maxChars) + "…";
  return <div className="text-gray-700" style={{
    whiteSpace: "normal",
    overflowWrap: "break-word",
    maxWidth: "100%"
  }} data-sentry-component="ShowMoreText" data-sentry-source-file="ShowMoreText.tsx">
      <p>{displayedText}</p>
      {shouldTruncate && <button onClick={toggleText} className="text-blue-600 hover:underline mt-1 text-sm">
          {isExpanded ? "Show Less" : "Show More"}
        </button>}
    </div>;
};
export default ShowMoreText;